module.exports = __webpack_public_path__ + "media/images/bg-voo-9ba519039d16384a22eae351b95dc389.jpg";